import React from 'react';
import FileCard from "../File/Card";
import classNames from 'classnames';
import {withStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid/Grid";

class ShortCards extends React.Component {
    render() {
        const {files, classes} = this.props;

        return (
            <Grid container className={classNames(classes.fileGrid, classes.vSpaces)}>
                {files.map((file, idx) => (
                    <Grid item key={`file${idx}`}>
                        <FileCard
                            file={file}
                            className={classes.fileCard}
                        />
                    </Grid>
                ))}
            </Grid>
        )
    }
}

const styles = theme => ({
    fileGrid: {
        justifyContent: "space-evenly",
    },
    fileCard: {
        maxWidth: 350,
    },
});


export default withStyles(styles)(ShortCards);


// WEBPACK FOOTER //
// ./resources/assets/js/components/File/ShortCards.jsx